
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LocationData } from '@/types/locations';
import LocationCard from '../LocationCard/LocationCard.vue';
import { Action } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { DeselectLocation, SelectLocationFromMap } from '@/store/modules/campaign-wizard/types';

@Component({
  components: { LocationCard },
  name: 'MapPopupLocationCard',
})
export default class MapPopupLocationCard extends Vue {
  @Prop({ required: true }) location!: LocationData;
  @Prop({ required: true, type: Array }) selectedLocations!: LocationData[];

  @Action('selectLocationFromMap', { namespace: namespaces.CampaignWizardModule })
  public selectLocationFromMap!: SelectLocationFromMap;

  @Action('deselectLocation', { namespace: namespaces.CampaignWizardModule })
  public deselectLocation!: DeselectLocation;

  // Use a local data property to avoid prop mutation
  localSelectedLocations: LocationData[] = [];

  get isSelected(): boolean {
    return this.localSelectedLocations.some(({ ID }) => ID === this.location.ID);
  }

  // Update local data when prop changes
  @Watch('selectedLocations', { immediate: true, deep: true })
  onSelectedLocationsChange(newSelectedLocations: LocationData[]): void {
    this.localSelectedLocations = [...newSelectedLocations];
  }

  handleSelect(): void {
    this.selectLocationFromMap(this.location);
  }

  handleDeselect(): void {
    this.deselectLocation(this.location);
  }

  // Method to update selections from parent
  public updateSelections(newSelectedLocations: LocationData[]): void {
    this.localSelectedLocations = [...newSelectedLocations];
  }
}
